import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { fetchAdvisories, fetchFromCoastAPI } from './alternate-data.utils';

export const getHurricaneDataAsync = createAsyncThunk(
  'alternateData/getHurricaneData',
  async (arg, { getState, requestId }) => {
    const { currentRequestId, loading } = getState().alternateData;
    const { lastFullYear } = getState().options;

    let data = {
      hurricanes: [],
      tropStorms: [],
    };

    if (arg && loading && requestId === currentRequestId) {
      data = await fetchFromCoastAPI(arg, lastFullYear);
    }

    return data;
  }
);

export const getHurricaneAdvisoriesAsync = createAsyncThunk(
  'alternateData/getHurricaneAdvisories',
  async (arg, { getState, requestId }) => {
    const { currentAdvisoryRequestId, loadingAdvisories } =
      getState().alternateData;
    const { currentLocation } = getState().map;

    let advisories = [];

    if (loadingAdvisories && requestId === currentAdvisoryRequestId) {
      advisories = await fetchAdvisories(arg, currentLocation.geometry);
    }

    return advisories;
  }
);

const initialState = {
  loading: false,
  currentRequestId: undefined,
  loadingAdvisories: false,
  currentAdvisoryRequestId: undefined,
  hurricanes: [],
  tropStorms: [],
  advisories: [],
};

const alternateDataSlice = createSlice({
  name: 'alternateData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHurricaneDataAsync.pending, (state, action) => {
        if (!state.loading) {
          state.loading = true;
          state.currentRequestId = action.meta.requestId;
        }
      })
      .addCase(getHurricaneDataAsync.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.hurricanes = action.payload.hurricanes;
          state.tropStorms = action.payload.tropStorms;
          state.loading = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(getHurricaneDataAsync.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.hurricanes = [];
          state.tropStorms = [];
          state.loading = false;
          alert(
            'An error has occurred and the hurricane data being shown may not be accurate.'
          );
          state.currentRequestId = undefined;
        }
      })
      .addCase(getHurricaneAdvisoriesAsync.pending, (state, action) => {
        if (!state.loadingAdvisories) {
          state.loadingAdvisories = true;
          state.currentAdvisoryRequestId = action.meta.requestId;
        }
      })
      .addCase(getHurricaneAdvisoriesAsync.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loadingAdvisories &&
          state.currentAdvisoryRequestId === requestId
        ) {
          state.advisories = action.payload;
          state.loadingAdvisories = false;
          state.currentAdvisoryRequestId = undefined;
        }
      })
      .addCase(getHurricaneAdvisoriesAsync.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loadingAdvisories &&
          state.currentAdvisoryRequestId === requestId
        ) {
          state.advisories = [];
          state.loadingAdvisories = false;
          alert(
            'An error has occurred and the hurricane advisories being shown may not be accurate.'
          );
          state.currentAdvisoryRequestId = undefined;
        }
      });
  },
});

export default alternateDataSlice.reducer;
